var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    _vm.isChartEnabled ? 'text-chart-active' : 'text-chart-inactive',
    'px-2 py-4 hidden md:flex flex-none items-center border-b-2 mt-2px border-transparent hover:border-theme-accents hover:text-blue transition' ],on:{"click":function($event){return _vm.toggleChart()}}},[_c('SvgIcon',{attrs:{"name":"chart","view-box":"0 0 18 17"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }